import axios from "axios";
const API_URL = "https://firendscable.zentexus.com/api";
// const API_URL = "http://localhost/friends_cable_api/api";

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  mode: "no-cors",
});

export default axiosInstance;
